import { render, staticRenderFns } from "./DiskPhoto.vue?vue&type=template&id=610a078c&scoped=true"
import script from "./DiskPhoto.vue?vue&type=script&lang=js"
export * from "./DiskPhoto.vue?vue&type=script&lang=js"
import style0 from "./DiskPhoto.vue?vue&type=style&index=0&id=610a078c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610a078c",
  null
  
)

export default component.exports